<template>
  <el-popover
    v-model="innerVisible"
    placement="top"
    trigger="manual"
    width="620"
  >
    <el-table :data="groupRowData">
      <el-table-column :label="$t('CargoMsg.Cargo_Currency')" property="SOURCE_CURRENCY" width="50" />
      <el-table-column :label="$t('CargoMsg.Cargo_DebitAmountOccurredSource')" property="DEBIT_USD" width="130" />
      <el-table-column :label="$t('CargoMsg.Cargo_DebitAmountOccurredLocal')" property="DEBIT_RMB" width="140" />
      <el-table-column :label="$t('CargoMsg.Cargo_CreditAmountOccurredSource')" property="CREDIT_USD" width="130" />
      <el-table-column :label="$t('CargoMsg.Cargo_CreditAmountOccurredLocal')" property="CREDIT_RMB" width="140" />
    </el-table>
    <span slot="reference" style="color:deepskyblue;cursor:pointer;padding-left: 5px;" no="1" @click="clickHandler"> {{ btnLable }} <i :class="!innerVisible?'el-icon-caret-left':'el-icon-caret-top'" /> </span>
  </el-popover>
</template>

<script>
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'DebitCreditTotalGroup',
  props: {
    visible: { type: Boolean, required: true },
    rowData: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false
    }
  },
  computed: {
    groupRowData() {
      return this.groupingCalc(this.rowData)
    },
    btnLable() {
      return this.innerVisible ? this.$t('CargoMsg.Cargo_hidePop') : this.$t('CargoMsg.Cargo_dispPop')
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    groupingCalc(rowData) {
      const debitCreditTotalDataProvider = []
      for (const item of rowData) {
        if (!item['FLAG'] || item['FLAG'] === '1') { // 明细
          let totalCurrencyMap = {}
          let bExist = false
          for (const totalCurrency of debitCreditTotalDataProvider) {
            if (item.SOURCE_CURRENCY === totalCurrency.SOURCE_CURRENCY) {
              totalCurrencyMap = totalCurrency
              bExist = true
              break
            }
          }
          if (bExist) {
            totalCurrencyMap.DEBIT_USD = NumberUtils.parseNumber(totalCurrencyMap.DEBIT_USD, 2) + NumberUtils.parseNumber(item.DEBIT_USD, 2)
            totalCurrencyMap.DEBIT_RMB = NumberUtils.parseNumber(totalCurrencyMap.DEBIT_RMB, 2) + NumberUtils.parseNumber(item.DEBIT_RMB, 2)
            totalCurrencyMap.CREDIT_USD = NumberUtils.parseNumber(totalCurrencyMap.CREDIT_USD, 2) + NumberUtils.parseNumber(item.CREDIT_USD, 2)
            totalCurrencyMap.CREDIT_RMB = NumberUtils.parseNumber(totalCurrencyMap.CREDIT_RMB, 2) + NumberUtils.parseNumber(item.CREDIT_RMB, 2)
          } else {
            totalCurrencyMap.SOURCE_CURRENCY = item.SOURCE_CURRENCY
            totalCurrencyMap.DEBIT_USD = NumberUtils.parseNumber(item.DEBIT_USD, 2)
            totalCurrencyMap.DEBIT_RMB = NumberUtils.parseNumber(item.DEBIT_RMB, 2)
            totalCurrencyMap.CREDIT_USD = NumberUtils.parseNumber(item.CREDIT_USD, 2)
            totalCurrencyMap.CREDIT_RMB = NumberUtils.parseNumber(item.CREDIT_RMB, 2)
            debitCreditTotalDataProvider.push(totalCurrencyMap)
          }
        }
      }
      return debitCreditTotalDataProvider.length > 0 ? debitCreditTotalDataProvider : []
    },
    clickHandler() {
      this.$emit('clickCallBack')
    }
  }
}
</script>

<style scoped>

</style>
